import { connect, MapStateToProps } from 'react-redux';
import { Props } from './dre';
import { getDRE } from '../publicSession/selectors';

export type StateProps = Pick<Props, 'dre'>;

export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => ({
  dre: getDRE(state),
});

export default connect(mapStateToProps);
